import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDebounce } from "@qgiv/core-react";
import { SearchField } from "@qgiv/core-donor";
import { getTeams } from "@qgiv/p2p-registration";
import { useDispatch } from "react-redux";
import ModalStateContext from "../../ModalStateContext";

const SearchBar = ({
    formId,
    isVisible,
    placeholder = "",
    newTeams = [],
    updateTeams = () => {},
    classificationId = 0,
}) => {
    const dispatch = useDispatch();
    const { searchTerm, setIsSearching, setResults, setSearchTerm } =
        React.useContext(ModalStateContext);
    const handleChange = (e) => {
        const {
            target: { value },
        } = e;
        setSearchTerm(value);
    };
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    useEffect(() => {
        setIsSearching(true);
        const params = {
            searchTeams: true,
            searchKey: debouncedSearchTerm,
        };
        if (classificationId > 0) {
            params.classificationId = classificationId;
        }
        getTeams(formId, params).then((response) => {
            const {
                data: {
                    response: { teams = [] },
                },
            } = response;
            setResults([...teams, ...newTeams]);
            dispatch(updateTeams(teams));
            setIsSearching(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchTerm]);

    const searchFieldProps = {
        handleClearBtnClick: (e) => {
            e.preventDefault();
            setSearchTerm("");
        },
        onChange: handleChange,
        placeholder,
        value: searchTerm,
    };

    return (
        isVisible && (
            <div className="col col--12">
                <SearchField {...searchFieldProps} />
            </div>
        )
    );
};

SearchBar.propTypes = {
    // If classification on registration exists, will be id
    // if it does not exist, will be 0, used for setting getTeams params
    classificationId: PropTypes.number.isRequired,
    formId: PropTypes.number.isRequired,
    isVisible: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    newTeams: PropTypes.arrayOf(PropTypes.shape({})),
    updateTeams: PropTypes.func,
};

export default SearchBar;
